import Select from "common/Select/Select";
import { useLeverageSelectorsProps } from "@shared/features/tradingTerminal/common/types";
import React from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import useSignalLeverageWarningModal from "features/tradingTerminal/General/useSignalLeverageWarningModal.tsx";

const useLeverageSelectors = ({
  marginType,
  marginTypeOptions,
  marginTypeValidationInfo,
  leverage,
  leverageOptions,
  leverageValidationInfo,
  leverageDisabled,
  onChange,
}: useLeverageSelectorsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const setMultiplier = (leverage: number) => onChange("leverage", leverage);
  const { onMultiplierChange, leverageWarningModal } =
    useSignalLeverageWarningModal({ setMultiplier });

  const marginTypeError = marginTypeValidationInfo?.[1];
  const leverageError = leverageValidationInfo?.[1];

  const marginTypeSelector = (
    <Select<number>
      value={marginType}
      onChange={(marginType: number) => onChange("margin_type", marginType)}
      error={marginTypeError}
      style={{ width: "100%" }}
      options={marginTypeOptions.map((option) => ({
        value: option.value,
        label: option.name,
      }))}
      mobileTitle={t("labels.margin_type")}
    />
  );

  const multiplierSelector = (
    <Select<number>
      value={leverage}
      onChange={onMultiplierChange}
      error={leverageError}
      disabled={leverageDisabled}
      style={{ width: "100%" }}
      options={leverageOptions.map((option) => ({
        value: option.value,
        label: option.name + "x",
      }))}
      mobileTitle={t("labels.multiplier")}
    />
  );

  return {
    marginTypeSelector,
    multiplierSelector,
    marginTypeErrorMessage: marginTypeValidationInfo?.[0],
    multiplierErrorMessage: leverageValidationInfo?.[0],
    leverageWarningModal,
  };
};

export default useLeverageSelectors;
